import { useEffect, useState } from "react";
import { _LoginServices, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { SelectYearAccount } from "../../Talentohumano/GestionTH/PaymentAccount/SelectYearAccount";
import { BasicPage } from "../../theme/Component/BasicPage"
import { SelectMonths } from "../../contract/select/SelectMonths";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../theme/Component/BasicButton";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { DropDown } from "../../theme/Component/DropDown";
import { Modal } from "../../theme/Component/Modal";
import { ReportCredit } from "../../adminServices/guarantee/ReportCredit";
import { ExportXLSL } from "../../theme/Component/ExportXLSX";
import { AccountEditor } from "../../editor/AccountEditor";

export const SessionAudit = () => {

    const _service = useDataBean(_LoginServices);
    const { lista, setLista, bean, setBean } = _service;
    const [listaAll,setListaAll] = useState<any>([]);
    const [filter, setFilter] = useState<any>({
        FromYear: _single.getCurrenYear(),
        FromMonth: _single.getCurrentMonth()
    });
    const paginador = usePaginator();
    const [modalCSV, setModalCSV] = useState<any>({ name: 'Detallado', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });

    useEffect(() => {
        getReporte()
    }, [paginador.page])

    const getReporte = () => {
        _service.instance.getSessionsReport(paginador.page, 15, _single.cleanMap(filter)).then(
            (resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15);
            }
        )
    }
    const getALLReporte = () => {
        _service.instance.getSessionsReport(paginador.page, paginador.pages*15, _single.cleanMap(filter)).then(
            (resp: any) => {
                setListaAll(resp.List);
                
            }
        )
    }
    const head = [
        { title: 'ID', property: 'IDSession', visible: true, mask: MASK_NUMBER },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Usuario', property: 'EntityName', visible: true },
        { title: 'Fecha', property: 'InitDate', visible: true }
    ]
    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },

    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        )
    }
    const actions = (e: any) => {

        if (e.id === 1) {
            getALLReporte();
            setModalCSV({ ...modalCSV, "view": true });
        }
    }


    return (
        <BasicPage titulo="Sesiones de Ingreso">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector tittle="Año" value={filter.FromYear} onChange={(e) => { setFilter({ ...filter, "FromYear": e }) }} />
                </div>
                <div className="col-md-4">
                    <SelectMonths label="Mes" idSelector={filter.FromMonth} onChange={(e) => { setFilter({ ...filter, "FromMonth": e }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Usuario" idAccount={filter.IDAccount} onChange={(e)=>{setFilter({...filter,"IDAccount":e.IDAccount})}}/>
                </div>
                <div className="col-md-12 mt-2">
                    <BasicButton icon="" eventClick={getReporte}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean}
                        next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                    ></BasicTable>
                    <Modal modal={modalCSV} updateModal={setModalCSV}>
                        <div className="row">
                            <div className="col">
                                <ExportXLSL customName={"Sesiones"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + listaAll.length + " registros");
                                }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}